// extracted by mini-css-extract-plugin
module.exports = {"menu":"style_menu__3Qx2h","icon":"style_icon__1ypIq","title":"style_title__1E4bM","logo":"style_logo__3WXwW","logoContainer":"style_logoContainer__1nKDv"};